import { ArrowRight } from "lucide-react";

const TrustBar = () => (
  <section className="bg-primary text-primary-foreground">
    <div className="mx-auto grid max-w-[1344px] gap-10 px-5 py-14 md:px-8 lg:grid-cols-12 lg:items-center lg:py-16">
      <div className="lg:col-span-4">
        <p className="font-mono text-[10px] uppercase tracking-[.18em] text-primary-foreground/55">Un appel, quatre étapes</p>
        <h2 className="mt-3 max-w-[360px] text-[28px] font-semibold leading-tight tracking-tight">Le tri est fait avant que vous rappeliez.</h2>
      </div>
      <div className="grid gap-0 border-y border-primary-foreground/20 sm:grid-cols-4 lg:col-span-8 lg:border-y-0">
        {["Décroche","Comprend","Qualifie","Transmet"].map((x,i) => (
          <div key={x} className="flex items-center justify-between border-b border-primary-foreground/20 py-4 last:border-0 sm:block sm:border-b-0 sm:border-l sm:px-6">
            <span className="font-mono text-[10px] text-primary-foreground/50">0{i+1}</span>
            <p className="mt-1 text-sm font-semibold">{x}</p>
            {i < 3 && <ArrowRight className="h-4 w-4 opacity-40 sm:hidden" />}
          </div>
        ))}
      </div>
    </div>
  </section>
);
export default TrustBar;